import { CommonModule } from '@angular/common';
import { Component, viewChild, inject } from '@angular/core';
import { FormsModule, NgForm } from '@angular/forms';
import { Timestamp } from '@firebase/firestore';
import { ButtonComponent } from '../../../../../shared/components/button/button.component';
import { RideStudent } from '../../../../../shared/interfaces/ride-list-item';
import { RequestBuilderService } from '../../../../../shared/services/request-builder.service';
import moment from 'moment';
import { SelectChangeEvent, SelectModule } from 'primeng/select';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { TextareaModule } from 'primeng/textarea';
import { map, Observable, of } from 'rxjs';

@Component({
  selector: 'app-add-incident-report-dialog',
  standalone: true,
  imports: [CommonModule, FormsModule, ButtonComponent, TextareaModule, SelectModule],
  templateUrl: './add-incident-report-dialog.component.html',
  styleUrl: './add-incident-report-dialog.component.scss',
})
export class AddIncidentReportDialogComponent {
  ref = inject(DynamicDialogRef);
  config = inject(DynamicDialogConfig);
  private readonly requestBuilder = inject(RequestBuilderService);

  readonly incidentReportForm = viewChild.required<NgForm>('incidentReportForm');
  loading = false;
  incidentCount$: Observable<number> = of(0);
  students: RideStudent[] = [];
  dateOfService: moment.Moment = moment();
  clientName: string | undefined = '';
  selectedStudent: RideStudent | null = null;

  ngOnInit() {
    this.students = this.config.data.students.map((s: RideStudent) => {
      return { ...s, name: `${s.firstName} ${s.lastName}` };
    });
    this.dateOfService = typeof this.config.data.rideDateOfService == 'string' ? moment(this.config.data.rideDateOfService) : moment.unix((this.config.data.rideDateOfService as Timestamp).seconds);
  }

  ngAfterViewInit() {
    if (this.students.length == 1) {
      this.selectedStudent = this.students[0];
      this.clientName = this.students[0].payingClientName;

      this.incidentCount$ = this.requestBuilder.get(`rides/${this.config.data.uuid}/incident-reports/${this.students[0].id}`).pipe(map(res => (res.success ? res.data : 0)));
    }
  }

  setClient(e: SelectChangeEvent) {
    this.clientName = e.value.payingClientName;

    this.incidentCount$ = this.requestBuilder.get(`rides/${this.config.data.uuid}/incident-reports/${e.value.id}`).pipe(map(res => (res.success ? res.data : 0)));
  }

  confirmAction() {
    const incidentReportForm = this.incidentReportForm();
    if (incidentReportForm.invalid) return;

    this.loading = true;
    const body = {
      incidentDate: this.dateOfService,
      clientId: this.selectedStudent?.payingClientId,
      clientName: this.selectedStudent?.payingClientName,
      studentId: this.selectedStudent?.id,
      studentFirstName: this.selectedStudent?.firstName,
      studentLastName: this.selectedStudent?.lastName,
      partnerId: this.config.data.partnerId,
      partnerName: this.config.data.partnerName,
      description: incidentReportForm.value.incidentDescription,
      actionDescription: incidentReportForm.value.actionsAndRecommendations,
      internalNote: incidentReportForm.value.notes,
    };
    this.requestBuilder.post(`rides/${this.config.data.uuid}/incident-reports`, body).subscribe({
      next: res => {
        this.loading = false;
        this.ref.close({ confirmed: true });
      },
      error: err => {
        this.loading = false;
      },
    });
  }
}
